import React, {useEffect, useState} from 'react';
import {Col, Form, Row} from "react-bootstrap";

function AppWebReportTaetigkeitsberichtWetter(props) {

    const [aussenWetter, setAussenWetter] = useState("")
    const [innenWetter, setInnenWetter] = useState("")
    const [details, setDetails] = useState("")

    useEffect(() => {
        if (props.wetterData === undefined) {
            setAussenWetter("");
            setInnenWetter("")
            setDetails("")
        } else {
            setAussenWetter(props.wetterData.aussenWetter);
            setInnenWetter(props.wetterData.innenWetter)
            setDetails(props.wetterData.details)
        }
    }, [props.wetterData]);


    return (<>
        <Row>
            <Col>
                <label className="handwai-text-label-main">Wetter</label>
            </Col>
        </Row>
        <br/>
        <Row>
            <Col>
                <Form.Group as={Row}>
                    <Form.Label column sm="3"
                                className="handwai-text-label-normal"
                    >
                        {'Innen:'}
                    </Form.Label>
                    <Col sm="4">
                        <input type="text" className="table-input"
                               style={{width: "70px", height: "30px"}}
                               disabled={true}
                               value={innenWetter}
                        />
                    </Col>
                    <label className="handwai-text-label-normal">°C</label>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm="3"
                                className="handwai-text-label-normal"
                    >
                        {'Außen:'}
                    </Form.Label>
                    <Col sm="4">
                        <input type="text" className="table-input"
                               style={{width: "70px", height: "30px"}}
                               disabled={true}
                               value={aussenWetter}
                        />
                    </Col>
                    <label className="handwai-text-label-normal">°C</label>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm="3"
                                className="handwai-text-label-normal"
                    >
                        {'Details:'}
                    </Form.Label>
                    <Col sm="5">
                        <input type="text" className="table-input"
                               style={{width: "150px", height: "30px"}}
                               disabled={true}
                               value={details}
                        />
                    </Col>
                </Form.Group>
            </Col>
        </Row>
    </>);
}

export default AppWebReportTaetigkeitsberichtWetter;
